import { ClusterType } from '@/swagger/constants/credits-enums';

export const it = {
  departments: {
    pageTitle: 'Dipartimenti',
    list: {
      subTitle: 'Elenco Dipartimenti',
      team: 'Team: ',
      manager: 'Responsabile: ',
      viewDetails: 'Vedi dettagli',
      fields: {
        searchPlaceholder: 'Cerca',
      },
      noResults: 'Nessun dipartimento trovato',
      noResultsInfo: 'Per maggiori informazioni consulta la !{CTA1}! o !{CTA2}!.',
      ctaLabel1: 'guida',
      ctaLabel2: 'contattaci',
      noDepartmentName: 'Senza nome',
      unassignedMembers: {
        title: "Membri dell'organizzazione senza dipartimento",
        description: 'Alcuni membri non sono ancora stati assegnati a un dipartimento',
        table: {
          searchPlaceholder: 'Cerca',
          firstName: 'Nome',
          lastName: 'Cognome',
          email: 'Email',
          role: 'Ruolo Aziendale',
        },
      },
    },
    details: {
      departmentManager: 'Responsabile del dipartimento',
      manager: 'Responsabile: ',
      teamManager: 'Responsabile del team',
      noDepartmentName: 'Senza nome',
      noTeamName: 'Membri del dipartimento',
      validProfiles: 'Profili validi',
      profilesToCorrect: 'Profili da correggere',
      team: 'Team',
      goToPeople: 'Vai a Anagrafiche',
      teamMembers: 'Membri del team',
      members: 'Membri',
      tabs: {
        tab1: 'Dipartimento',
        team: 'Team',
        tab2: 'Assessment',
        tab3: 'Crediti',
      },
      managerNotExist:
        'I dati del responsabile non sono visibili perché il profilo non è censito in piattaforma. Aggiungi l’anagrafica per poter visualizzare tutte le informazioni.',
    },
    emptyStateNoPeople: {
      title: 'Dipartimenti',
      descriptionLine1: 'Non sono presenti anagrafiche complete.',
      descriptionLine2:
        'Per visualizzare i dati è necessario censire le anagrafiche dell’azienda nella sezione !{CTA}!.',
      ctaLabel: 'Anagrafiche',
    },
    emptyStateNoDepartments: {
      title: 'Dipartimenti',
      description:
        'Le anagrafiche caricate non contengono ancora informazioni su dipartimenti.\n\nPer creare dipartimenti e assegnare le persone, modifica le anagrafiche dalla sezione !{CTA}!. In questo modo potrai visualizzare insight più specifici per ogni dipartimento e team.',
      ctaLabel: 'Anagrafiche',
    },
    usefullInformations: {
      title: 'Materiali utili',
      boxTutorial: {
        title: 'Guarda il tutorial',
        description: 'Scopri come visualizzare e leggere i risultati dei tuoi dipartimenti',
        buttonLabel: 'Guarda ora',
      },
    },
    tabs: {
      assessment: {
        noCompletedEmployees: {
          title: 'Assessment',
          description:
            'Le anagrafiche caricate presentano degli errori o campi incompleti, controlla e correggi per inviare un assessment.',
          alert: {
            label: 'Accedi alla sezione !{CTA}! per procedere.',
            ctaLabel: 'Guida',
          },
        },
        noData: {
          title: 'Assessment',
          description:
            'Non hai ancora inviato l’assessment a nessun membro. Clicca su “Invia Assessment” per iniziare a raccogliere i risultati sulle skills.',
          button: {
            label: 'Invia Assessment',
          },
          alert: {
            label: 'Per saperne di più sul funzionamento dell’Assessment, consulta la !{CTA}!.',
            ctaLabel: 'Guida',
          },
        },
      },
      team: {
        assessment: {
          description:
            'Seleziona un questionario tra quelli sotto elencati per vedere i risultati.',
          intro: {
            description: {
              single:
                "I dati si riferiscono agli utenti del team che hanno completato l'assessment sulle ”{{nameSurvey}}”. La base di analisi è costituita da {{totalCompletedSurveys}} utente.",
              plural:
                "I dati si riferiscono agli utenti del team che hanno completato l'assessment sulle ”{{nameSurvey}}”. La base di analisi è costituita da {{totalCompletedSurveys}} utenti.",
            },
          },
          recap: {
            title: 'Punteggio medio per {{templateName}}',
            description:
              'Il grafico riporta i punteggi medi (scala 0-7) delle {{metricsCount}} {{templateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
            insignBox: {
              title: 'Insight',
              proTitle: 'Punti di forza',
              conTitle: 'Punti di debolezza',
            },
          },
          resultsTeamVsDepartmentVsOrganization: {
            title: 'Andamento del team rispetto al dipartimento e all’organizzazione',
            description:
              'Confronto tra i punteggi medi del team, del dipartimento di appartenenza e dell’intera organizzazione nell’edizione selezionata.',
            labelTooltipChart:
              'Punteggio: {{current}} pt\n\n{{depValue}} vs media dipartimento\n\n{{orgValue}} vs media organizzazione',
            legend: {
              teamAverage: 'Team ({{total}} persone)',
              depAverage: 'Dipartimento ({{total}} persone)',
              orgAverage: 'Organizzazione ({{total}} persone)',
            },
          },
          distributionBox: {
            title: 'Distribuzione dei punteggi per skill',
            description:
              'Il grafico mostra la percentuale di utenti del team collocati nei tre livelli di competenza per ciascuna skill.',
          },
        },
      },
      department: {
        assessment: {
          description:
            'Seleziona un questionario tra quelli sotto elencati per vedere i risultati.',
          intro: {
            description: {
              single:
                "I dati si riferiscono agli utenti del dipartimento che hanno completato l'assessment sulle ”{{nameSurvey}}”. La base di analisi è costituita da {{totalCompletedSurveys}} utente.",
              plural:
                "I dati si riferiscono agli utenti del dipartimento che hanno completato l'assessment sulle ”{{nameSurvey}}”. La base di analisi è costituita da {{totalCompletedSurveys}} utenti.",
            },
          },
          recap: {
            title: 'Punteggio medio per {{templateName}}',
            description:
              'Il grafico riporta i punteggi medi (scala 0-7) sulle {{metricsCount}} {{templateName}}, considerate fondamentali per affrontare in modo efficace le sfide dell’AI.',
            insignBox: {
              title: 'Insight',
              proTitle: 'Punti di forza',
              conTitle: 'Punti di debolezza',
            },
          },
          resultsDepartmentVsOrganization: {
            title: 'Andamento del dipartimento rispetto all’organizzazione',
            description:
              'Confronto tra i punteggi medi del dipartimento e quelli dell’intera organizzazione nell’edizione selezionata.',
            labelTooltipChart: 'Punteggio: {{current}} pt\n\n{{diffValue}} vs media organizzazione',
            legend: {
              depAverage: 'Dipartimento ({{total}} persone)',
              orgAverage: 'Organizzazione ({{total}} persone)',
            },
          },
          distributionBox: {
            title: 'Distribuzione dei punteggi per skill',
            description:
              'Il grafico mostra la percentuale di utenti del dipartimento collocati nei tre livelli di competenza per ciascuna skill.',
          },
        },
      },
      credits: {
        noData: {
          title: 'Crediti',
          description:
            'Non ci sono ancora dati disponibili: invia l’assessment per iniziare a monitorare il consumo dei crediti.',
        },
        recap: {
          title: 'Team {{name}}',
          nextRecharge: 'Rinnovo crediti: !{DATE}! ({{days}} giorni rimanenti)',
          description:
            "I dati considerano i profili del dipartimento invitati a registrarsi su Slash (inclusi gli utenti con account in sospeso). Sono esclusi i profili caricati a cui non è mai stato inviato l'assessment iniziale.",
          descriptionTeam:
            'I dati considerano solo i profili del team invitati a registrarsi su Slash (inclusi gli utenti con account in sospeso). Sono esclusi i profili caricati ma a cui non è mai stato inviato il primo assessment',
        },
        progress: {
          total: 'Crediti spesi nel periodo selezionato: ',
          overall: 'Utilizzo dei crediti',
          overallTooltip:
            'La percentuale indica la quota di crediti utilizzati rispetto all’assegnazione complessiva disponibile per il dipartimento. Poiché i crediti si accumulano per tre mesi, l’utilizzo reale mensile può superare il 100%, anche se i valori visualizzati non andranno mai oltre tale soglia.',
          media: 'Media mensile di utilizzo: ',
        },
        cluster: {
          labelPerson: 'persone in {{clusterName}}',
          title: 'Dettaglio di utilizzo crediti',
          description:
            'Ogni fascia mostra il livello medio di utilizzo dei crediti da parte degli utenti del dipartimento. La distribuzione aiuta a capire quanti utenti utilizzano pienamente i crediti disponibili e quanti hanno margine di coinvolgimento',
          descriptionTeam:
            'Ogni fascia mostra il livello medio di utilizzo dei crediti da parte degli utenti del team. La distribuzione aiuta a capire quanti utenti utilizzano pienamente i crediti disponibili e quanti hanno margine di coinvolgimento',
          table: {
            cluster: 'Cluster',
            clusterTooltip:
              'I cluster sono calcolati sul consumo dei crediti complessivi nel periodo selezionato',
            media: 'Media crediti',
            mediaLabel: 'crediti/mese',
            person: 'Persone',
            personLabel: 'persone',
          },
          [ClusterType.INATTIVI]: {
            label: 'Inattivi',
            subLabel: '0%',
          },
          [ClusterType.SOTTO_UTILIZZATORI]: {
            label: 'Sotto-utilizzatori',
            subLabel: '1-29%',
          },
          [ClusterType.OCCASIONALI]: {
            label: 'Occasionali',
            subLabel: '30-49%',
          },
          [ClusterType.MODERATI]: {
            label: 'Moderati',
            subLabel: '50-69%',
          },
          [ClusterType.REGOLARI]: {
            label: 'Regolari',
            subLabel: '70-89%',
          },
          [ClusterType.INTENSIVI]: {
            label: 'Intensivi',
            subLabel: '90-100%',
          },
        },
        team: {
          title: 'Utilizzo dei crediti per team',
          description: 'Dettaglio dell’utilizzo dei crediti per ciascun team del dipartimento.',
          buttonCta: 'Visualizza crediti',
          noTeamName: 'Senza nome',
          creditPerPerson: 'Consumo medio per persona: !{TOTAL}! crediti',
        },
        trend: {
          title: 'Trend utilizzo crediti',
          description:
            "Analisi dell'utilizzo medio dei consumi di crediti nel dipartimento nel periodo selezionato.",
          descriptionTeam: 'Andamento dei consumi del team nel periodo selezionato.',
          chartTitle: 'Trend utilizzo crediti',
          averageMonthlyUsage: 'Media mensile di utilizzo',
          averageMonthlyUsageTooltip:
            'Indica il numero medio di crediti spesi da ciascun dipendente nel periodo selezionato. Nei periodi trimestrale il valore rimane conteggiato su base mensile.',
          creditLabel: 'crediti per persona',
          creditsLabel: 'crediti',
          trendLabel: 'Trend trimestre',
          trendLabelTooltip:
            'Mostra la variazione dell’utilizzo medio dei crediti per persona rispetto al periodo precedente dello stesso tipo (mese o trimestre). Serve a individuare trend di crescita o di calo.',
        },
      },
    },
    tutorial: {
      title: 'I tuoi dipartimenti',
      slides: {
        slide1: {
          title: 'Esplora la panoramica dei dipartimenti',
          description:
            'Visualizza l’elenco completo di tutti i reparti della tua organizzazione. Da qui puoi selezionare un dipartimento specifico e accedere alla sua pagina dedicata.',
        },
        slide2: {
          title: 'Consulta le informazioni del dipartimento',
          description:
            'In ogni dipartimento trovi due schede: “Dipartimento” con le anagrafiche delle persone associate al dipartimento e “Assessment” dove puoi controllare i progressi del team.',
        },
        slide3: {
          title: 'Approfondisci ogni team',
          description:
            'Per ogni team del dipartimento sono disponibili le schede di “Team” e “Assessment”, per permetterti di analizzare nel dettaglio informazioni, performance e utilizzo delle risorse a livello più granulare.',
        },
      },
    },
  },
};
